import React from 'react';
import { Link } from 'react-router-dom';
import heroImg from '../images/businessScale.jpg';

const Cta = () => {
  return (
    <section
      id="cta"
      className="relative py-20 px-6 lg:px-24 text-white flex items-center justify-center"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: -2,
        }}
      ></div>

      {/* Black Overlay */}
      <div className="absolute inset-0 bg-black opacity-50 z-[-1]"></div>

      {/* Content */}
      <div className="relative max-w-7xl flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* Text Content */}
        <div className="flex-1 text-center lg:text-left space-y-6">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
            Are you ready to scale your business?
          </h2>
          <p className="text-lg md:text-xl font-medium">
            Get in touch and let us build something amazing{' '}
            <span className="font-black">together!</span>
          </p>
        </div>

        {/* Button */}
        <div className="flex-1 flex justify-center lg:justify-end">
          <Link
            to="/contact"
            className="bg-[#15467a] text-white font-semibold px-8 py-4 rounded-2xl shadow-lg inline-flex items-center space-x-2 transition-all duration-300 hover:bg-[#1b5a99]"
          >
            <span>Send a Message</span>
            <svg
              className="w-5 h-5 transform transition-transform duration-300 group-hover:translate-x-2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Cta;
